import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import baseHelper from '../../../helpers/BaseHelper';
import Spinner from '../../../components/Spinner';
import * as types from '../../../redux/futures/store/types';
import storeActions from '../../../redux/futures/store/actions';

class ListStaffs extends React.Component {
    static propTypes = {
        currentUser: PropTypes.object,
        onCancel: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            staffs: [],
        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {

        // Check if previous action was completed
        if (nextProps.action == types.LIST_STAFFS) {
            // Check which action was completed

            // Check if action was successful
            if (nextProps.status) {
                window.LadiUI.toastr('success', '', nextProps.message);

                this.setState({
                    staffs: nextProps.staffs
                });
            } else {
                // Show error message if action failed
                window.LadiUI.toastr('error', '', nextProps.message);
            }
        }
    }

    getRoles(staff) {
        let roles = '';

        if (staff.ladipage_role) {
            roles += `LadiPage (${staff.ladipage_role.role.toLowerCase()}) `;
        }
        if (staff.ladisale_role) {
            roles += `, LadiSale (${staff.ladisale_role.role.toLowerCase()}) `;
        }
        if (staff.ladigoal_role) {
            roles += `, LadiGoal (${staff.ladigoal_role.role.toLowerCase()}) `;
        }
        if (staff.ladicrm_role) {
            roles += `, LadiCRM (${staff.ladicrm_role.role.toLowerCase()}) `;
        }
        if (staff.ladiflow_role) {
            roles += `, LadiFlow (${staff.ladiflow_role.role.toLowerCase()}) `;
        }
        if (staff.ladishare_role) {
            roles += `, LadiShare (${staff.ladishare_role.role.toLowerCase()}) `;
        }
        if (roles.startsWith(',')) {
            return roles.substring(1);
        }
        if (roles.endsWith(',')) {
            return roles.substring(0, roles.length - 1);
        }
        return roles;
    }

    getTeams(staff) {
        if (staff.ladipage_role && staff.ladipage_role.list_teams) {
            return staff.ladipage_role.list_teams.map(team => team.team_name).join(', ');
        }
        return '';
    }


    render() {
        const { currentUser } = this.props;
        const { staffs } = this.state;
        const isLoading = this.props.loading && (this.props.waitting == types.LIST_STAFFS);

        return (
            <div id="modal-list-staffs" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-list-staffs" style={{ zIndex: '21' }}>
                <div className="ladiui-modal-content">
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-list-staffs">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-list-staffs" />
                        </button>
                        <h3>Thông tin các nhân viên</h3>
                    </div>
                    <div className="ladiui-modal-body">

                        <table className="ladiui table">
                            <thead>
                                <tr>
                                    <th className="text-left">Họ tên</th>
                                    <th className="text-left">Email</th>
                                    <th className="text-left">Vai trò</th>
                                    <th className="text-left">Đội nhóm</th>
                                </tr>
                            </thead>
                            <tbody>
                                {staffs.map((staff, index) => (
                                    <tr key={index}>
                                        <td>{staff.fullname}</td>
                                        <td>{staff.email}</td>
                                        <td>{this.getRoles(staff)}</td>
                                        <td>{this.getTeams(staff)}</td>

                                    </tr>
                                ))}

                            </tbody>
                        </table>
                        {this.props.loading && <Spinner />}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    staffs: state.store.staffs,
    loading: state.store.loading,
    waitting: state.store.waitting,
    status: state.store.status,
    message: state.store.message,
    action: state.store.action
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ListStaffs); 